
module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');



//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/engine.io-client/lib/index.js
// module id = ../../../../engine.io-client/lib/index.js
// module chunks = 4